// extracted by mini-css-extract-plugin
export default {"sawoContainer":"Signin_sawoContainer__rqiEe","contact_container":"Signin_contact_container__2p8jf","contact":"Signin_contact__uJdqe"};